export function stripLeadingSlashes(string: string) {
    return string.replace(/^\/+/, '');
}
